import React from 'react';
import { Form } from 'antd';
import ReactQuill from 'react-quill';


const RichTextEditor = ({ name, label, rules, handleOnChange, valueName, isDisabled = false, theme, modules, formats }) => {
    return (
        <Form.Item label={label} name={name} rules={rules} initialValue={''}>
            <ReactQuill  value={valueName} onChange={handleOnChange} theme={theme} modules={modules} formats={formats} className='white-background'/>
        </Form.Item>
    );
};

export default RichTextEditor;